export default __webpack_public_path__ + "static/media/volume-mute.ee93c87e.png";